import req from '@sportninja/common/api/request'
import { ROUTES } from '@sportninja/common/constants/app'
import { BillingScheduleItem } from '@sportninja/common/types/Registration'
import { useUIContext } from '../context/UIContext'

export function useBillingActions() {
  const { addPdfLoading, removePdfLoading, openSendInvoiceModal } =
    useUIContext()

  const handleDownloadPdf = async (billingId: string) => {
    addPdfLoading(billingId)
    try {
      const receiptResponse = await req(
        `/billing/schedule/${billingId}/receipt`
      )
      const pdf = await req(`/billing/schedule/${billingId}/receipt/pdf`, {
        parseJSON: false,
      })
      const blob = await pdf.blob()
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `${receiptResponse?.data?.charge?.stripe_id}.pdf`
      link.click()
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Unknown error'
      alert(
        `There was an error generating the report. ${message} Please try again.`
      )
    } finally {
      removePdfLoading(billingId)
    }
  }

  const handlePayment = (record: BillingScheduleItem) => {
    window.open(
      `${ROUTES.REGISTRATION_PAYMENT}?billingId=${record.uid}`,
      '_blank'
    )
  }

  const handleSendInvoice = (billing: BillingScheduleItem) => {
    openSendInvoiceModal(billing)
  }

  return {
    handleDownloadPdf,
    handlePayment,
    handleSendInvoice,
  }
}
